import SocialLinks from './pages/SocialLinks';

function App() {
  return <SocialLinks />;
}

export default App;
